import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';

import CompactLayout from 'src/layouts/compact';

import { rootRoute } from './root';

const EULAPage = lazy(() => import('src/sections/eula/eula-view'));


export const eulaRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'eula',
  component: () => <CompactLayout><EULAPage/></CompactLayout>,
});

